import "./Livecomment.css"
import hall from "./../livescoreImage/newpage.jpg"

const  Livecomment = ({dark}) => {
    return <div className="livecommentWrapper"> 
            <section className="firstsection">
                <menu style={dark ? {backgroundColor: "transparent"} : {}}>
                    <h1 className="title" style={dark ? {color: "#fafafaff"} : {}}>Comments (3)</h1>
                    <input style={dark ? {backgroundColor: "#313131ff", color: "#fafafaff"} : {}} type="text" placeholder="What do you think?" />
                </menu>
                <div className="commentWrap">
                    <div className="comment" style={{flexDirection: "row"}}>
                        <img src={hall} alt="" />
                        <span>
                            <h2 style={dark ? {color: "#fafafaff"} : {}}>FadaWebs</h2>
                            <h5 style={dark ? {color: "#c9c8c8ff"} : {}}>5hr ago</h5>
                            <p style={dark ? {color: "#d6d6d6ff"} : {}}>i don’t like the way arsenal pressed, they showed they are not ready in 
                                winning title. i just feel they need to find a solution to the defender 
                                and the striking position and they will be in  a top level</p>
                                <span className="reply">
                                    <h5 style={dark ? {color: "#c9c8c8ff"} : {}}>reply</h5>
                                
                                </span>
                        </span>
                    </div>
                    
                    <div className="comment" style={{flexDirection: "row"}}>
                        <img src={hall} alt="" />
                        <span>
                            <h2 style={dark ? {color: "#fafafaff"} : {}}>FadaWebs</h2>
                            <h5 style={dark ? {color: "#c9c8c8ff"} : {}}>5hr ago</h5>
                            <p style={dark ? {color: "#d6d6d6ff"} : {}}>i don’t like the way arsenal pressed, they showed they are not ready in 
                                winning title. i just feel they need to find a solution to the defender 
                                and the striking position and they will be in  a top level</p>
                                <span className="reply">
                                    <h5 style={dark ? {color: "#c9c8c8ff"} : {}}>reply</h5>
                                
                                </span>
                        </span>
                    </div>
                </div>
            </section>
    </div>
};

export default Livecomment;